import { BREAKPOINT } from '@npco/zeller-design-system'
import styled from 'styled-components'

export const Emphasis = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.BLUE_1000};
  position: relative;
  margin-right: 4px;
`

export const EmphasisPill = styled.span`
  color: ${({ theme }) => theme.colors.DARK_BLUE};
  background-color: ${({ theme }) => theme.colors.BRIGHT_GREEN};
  border-radius: 100px;
  padding: 0 14px;
  position: relative;
`

export const Asterisk = styled.span`
  position: absolute;
  top: -8px;
  right: -2px;
  scale: 0.6;
`

export const Interest = styled.span`
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 1.1428;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    font-size: 2.1875rem;
  }
`

export const Pa = styled.span`
  margin-left: 4px;
  font-weight: 700;
  line-height: 1;
  font-size: 1rem;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    font-size: 1.25rem;
  }
`

export const MayAsterisk = styled.span`
  font-weight: 700;
  font-size: 0.75rem;
  line-height: 1;
  position: absolute;
  top: 10px;
  right: 10px;

  @media screen and (min-width: ${BREAKPOINT.SM}px) {
    top: 14px;
    right: 10px;
  }
`
